import React, { useState } from 'react';
import { useGetUserProfileQuery, useUpdateUserPasswordMutation, useGetMyPaymentsQuery } from '../redux/api/roomBookingApi';
import { useNavigate, useLocation } from 'react-router-dom';

const Profile = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { data, error, isLoading, refetch } = useGetUserProfileQuery();
    // const [updatePassword, { isLoading: isUpdating }] = useUpdateUserPasswordMutation();
    const { data: paymentsData, isLoading: isPaymentsLoading } = useGetMyPaymentsQuery();

    const [activeTab, setActiveTab] = useState(location.state?.activeTab || 'bookings'); // Default tab

    // Password State
    const [passwords, setPasswords] = useState({
        currentPassword: '',
        newPassword: '',
        confirmPassword: ''
    });
    const [msg, setMsg] = useState({ type: '', text: '' });

    if (isLoading) return <div className="container py-5 text-center">Loading Profile...</div>;

    if (error) {
        // If 401, redirect to login
        if (error.status === 401) {
            localStorage.removeItem('uid');
            navigate('/login');
        }
        return <div className="container py-5 text-center text-danger">Error loading profile. Please login again.</div>;
    }

    const { user, bookings } = data?.data || {};

    // Removed handlePasswordChange logic

    return (
        <div className="th-checkout-wrapper space-top space-extra-bottom">
            <div className="container">
                <div className="row">
                    {/* User Sidebar / Info */}
                    <div className="col-lg-4 mb-4">
                        <div className="card shadow-sm">
                            <div className="card-body text-center">
                                <div className="mb-3">
                                    <i className="fas fa-user-circle fa-5x text-secondary"></i>
                                </div>
                                <h4>{user?.full_name}</h4>
                                <p className="text-muted">{user?.email_id}</p>
                                <p className="text-muted">{user?.phone_num}</p>
                                <hr />
                                <div className="d-grid gap-2">
                                    <button
                                        className={`btn ${activeTab === 'bookings' ? 'btn-primary' : 'btn-outline-primary'}`}
                                        onClick={() => setActiveTab('bookings')}
                                    >
                                        <i className="fas fa-list-alt me-2"></i> My Bookings
                                    </button>
                                    <button
                                        className={`btn ${activeTab === 'payments' ? 'btn-primary' : 'btn-outline-primary'}`}
                                        onClick={() => setActiveTab('payments')}
                                    >
                                        <i className="fas fa-credit-card me-2"></i> Payment History
                                    </button>
                                    {/* Security Tab Removed as per request */}
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Main Content */}
                    <div className="col-lg-8">
                        <div className="card shadow-sm">
                            <div className="card-header bg-white">
                                <h5 className="mb-0">
                                    {activeTab === 'bookings' ? 'My Bookings' : 'Payment History'}
                                </h5>
                            </div>
                            <div className="card-body">

                                {/* Bookings Tab */}
                                {activeTab === 'bookings' && (
                                    <div className="table-responsive">
                                        {bookings && bookings.length > 0 ? (
                                            <table className="table table-hover">
                                                <thead className="table-light">
                                                    <tr>
                                                        <th>Booking ID</th>
                                                        <th>Room</th>
                                                        <th>Check-In</th>
                                                        <th>Check-Out</th>
                                                        <th>Amount</th>
                                                        <th>Status</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {bookings.map((booking) => (
                                                        <tr key={booking.booking_id}>
                                                            <td><small>{booking.booking_id}</small></td>
                                                            <td>
                                                                {booking.allocated_room_no ? (
                                                                    <span className="text-success fw-bold">{booking.allocated_room_no}</span>
                                                                ) : (
                                                                    <span className="text-muted small">Not Allocated Yet</span>
                                                                )}
                                                            </td>
                                                            <td>{new Date(booking.checkin_date).toLocaleDateString('en-GB')}</td>
                                                            <td>{new Date(booking.check_out_date).toLocaleDateString('en-GB')}</td>
                                                            <td>₹{booking.payment_amount}</td>
                                                            <td>
                                                                <div className="d-flex align-items-center gap-2">
                                                                    <span className={`badge bg-${booking.payment_status === 'completed' ? 'success' : 'warning'} text-white`}>
                                                                        {booking.payment_status === 'completed' ? 'PAID' : 'PAYABLE'}
                                                                    </span>
                                                                    {booking.receipt_path && (
                                                                        <button
                                                                            className="btn btn-sm btn-outline-success ms-2"
                                                                            onClick={() => downloadReceipt(booking.booking_id, 'room')}
                                                                            title="Download Invoice"
                                                                        >
                                                                            <i className="fas fa-file-invoice-dollar"></i>
                                                                        </button>
                                                                    )}
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        ) : (
                                            <p className="text-center py-4">No bookings found.</p>
                                        )}
                                    </div>
                                )}

                                {/* Payments Tab */}
                                {activeTab === 'payments' && (
                                    <div className="table-responsive">
                                        {isPaymentsLoading ? <p className="text-center">Loading payments...</p> :
                                            paymentsData && paymentsData.data && paymentsData.data.length > 0 ? (
                                                <table className="table table-hover">
                                                    <thead className="table-light">
                                                        <tr>
                                                            <th>Date</th>
                                                            <th>Booking ID</th>
                                                            <th>Type</th>
                                                            <th>Details</th>
                                                            <th>Amount</th>
                                                            <th>Status</th>
                                                            <th>Action</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {paymentsData.data.map((payment) => (
                                                            <tr key={payment._id}>
                                                                <td>{new Date(payment.date).toLocaleDateString('en-GB')}</td>
                                                                <td><small>{payment.booking_id}</small></td>
                                                                <td>{payment.type}</td>
                                                                <td>{payment.details}</td>
                                                                <td>₹{payment.amount}</td>
                                                                <td>
                                                                    <span className={`badge bg-${payment.pay_status === 'completed' ? 'success' : 'danger'} text-white`}>
                                                                        {(payment.pay_status || 'Pending').toUpperCase()}
                                                                    </span>
                                                                </td>
                                                                <td>
                                                                    {payment.receipt_type === 'seva' && payment.pay_status === 'completed' && (
                                                                        <button
                                                                            className="btn btn-sm btn-info text-white me-2"
                                                                            onClick={() => downloadReceipt(payment.booking_id, 'seva')}
                                                                        >
                                                                            <i className="fas fa-download"></i> Receipt
                                                                        </button>
                                                                    )}
                                                                    {payment.receipt_type === 'room' && (
                                                                        <button
                                                                            className="btn btn-sm btn-success text-white"
                                                                            onClick={() => downloadReceipt(payment.booking_id, 'room')}
                                                                        >
                                                                            <i className="fas fa-download"></i> Receipt
                                                                        </button>
                                                                    )}
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            ) : (
                                                <p className="text-center py-4">No payment history found.</p>
                                            )}
                                    </div>
                                )}

                                {/* Security Tab Removed */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

// Add download function
const downloadReceipt = async (id, type) => {
    try {
        const url = type === 'seva' ? '/api/payment/receipt/seva' : '/api/payment/receipt/room';
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                // Add Authorization header if needed, but endpoint might be public or rely on cookie?
                // The API route I made was using `sevaBookingController.printSevaReceipt` which reads body.id
            },
            body: JSON.stringify({ id })
        });

        if (!response.ok) throw new Error("Failed to download");

        const blob = await response.blob();
        const downloadUrl = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = downloadUrl;
        link.download = `receipt_${type}_${id}.pdf`;
        document.body.appendChild(link);
        link.click();
        link.remove();
    } catch (err) {
        console.error(err);
        alert("Error downloading receipt: " + err.message);
    }
};

export default Profile;
